import authFetch from "components/Authentication/AuthFetch"
const api_url = process.env.REACT_APP_OIDC_AUTH_URL;

export const endSync = () => {
  return authFetch(`${api_url}/strava/api/end_sync`, "POST")
}

export const finishSync = (stravaAuthCode) => {
  return authFetch(`${api_url}/strava/api/finish_sync`, "POST", JSON.stringify(stravaAuthCode))
}



// WEBPACK FOOTER //
// ./src/api/strava/sync.js